import { formatLabel } from "./utils"

// Stacked bar chart
const spotlight_figure_2 = {
  figureNumber: "1.2",
  title: "Largest SDR Allocation in IMF History",
  caption:
    "New SDR allocation of $650 billion, of which about $275 billion went to emerging market and developing economies.",
  source: "Sources: IMF, Finance Department; and IMF, Strategy, Policy and Review Department.",
  data: {
    labels: [
      formatLabel("1970-72 General allocation", 10),
      formatLabel("1979-81 General allocation", 10),
      formatLabel("2009 Special allocation", 10),
      formatLabel("2009 General allocation", 10),
      formatLabel("2021 General allocation", 10),
    ],
    datasets: [
      {
        data: [9.3, 12.1, 21.5, 161.2, 456.5],
        borderColor: "#004171",
        backgroundColor: [
          "#00A8A9",
          "#00A8A9",
          "#00A8A9",
          "#00A8A9",
          "#E15B29",
        ],
        fill: false,
        barThickness: 12,
      },
    ],
  },
  options: {
    maintainAspectRatio: false,
    responsive: true,
    aspectRatio: 0.7,
    height: "medium",
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        title: function (tooltipItem, data) {
          let label = tooltipItem[0].label.replace(/,/g, " ")
          return label
        },
      },
    },
    scales: {
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: "Billions of SDRs",
          },
        },
      ],
    },
  },
}

export default spotlight_figure_2
